export default "__VITE_ASSET__e2045154__"